export const postMessage = (message: string) => {
    const webkitMessageHandler = window.webkit?.messageHandlers?.javascriptListener;
    const reactNativeWebViewHandler = window.ReactNativeWebView;

    if (webkitMessageHandler?.postMessage) {
        webkitMessageHandler.postMessage(message);
    }
    if (reactNativeWebViewHandler?.postMessage) {
        reactNativeWebViewHandler.postMessage(message);
    }
};

export const remoteLog = (toLog: any) => {
    console.log(toLog);

    const message = JSON.stringify({
        type: "RemoteLog",
        data: toLog,
    });
    postMessage(message);
};
